import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { cssProperties } from "../utils/commonCssProperties";
import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { MdOutlineFileDownload } from "react-icons/md";
import CircularProgress from '@mui/material/CircularProgress';
import { useSelector } from "react-redux";




export default function CandidateDumpTable({ tableData, columnData, handleGenerateFunc,  generatedRows = null, handleDownloadDump, handleRegenrateFunc}) {
  let [rows, setRows] = React.useState(tableData);
  React.useEffect(() => {
    setRows(tableData);
  }, [tableData]);

  const { pendingRows, downloadUrls } = useSelector((state) => state.candidateReducer);
  const tableLoader = useSelector((state) => state?.commonReducer?.tableLoader);

  return (
    <div>
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        width: "100%",
        mb: 2,
        pr:2,
        mt:4,
      }}
    >
    <TableContainer
      component={Paper}
      sx={{
        background: "none",
        border: `1px solid ${"#0F4F96"}`,
        boxShadow: "none",
        maxHeight: 350,
      }}
    >
          <Table
            size="small"
            sx={{ minWidth: 650, borderCollapse: "collapse" }}
            aria-label="simple table">
            <TableHead>
              <TableRow>
                {columnData?.map((obj, i) => {
                  return (
                <TableCell
                  sx={{
                    color: "#0F4F96",
                    textAlign: i === 0 ? "left" : "center",
                    borderRight: i !== columnData.length - 1
                      ? `1.2px solid ${"#0F4F96"}`
                      : "none",
                      width: i === 1 ? "165px" : i === 1 ? "261px" : "auto",
                  }}
                  key={i}
                >
                  {obj.name}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {/* Implement loader below */}
          {tableLoader ? (
                <TableRow>
              <TableCell
                colSpan={columnData?.length}
                component="td"
               
                sx={{ textAlign: "center", color: "#0F4F96", }}
              >
                Loading...
              </TableCell>
            </TableRow>
          ) : rows?.length > 0 ? (
            rows?.map((row, i) => {
              const isPending = pendingRows[row.courseid];
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              const endDate = new Date(row?.regenddate);
              endDate.setHours(0, 0, 0, 0);
              return (
              <TableRow key={i}>
                {columnData?.map((param, i) => (
                  <TableCell
                    component="td"
                    key={i}
                    sx={{ textAlign: i === 0 ? "left" : "center", borderRight: i !== columnData.length - 1 ? `1.2px solid ${"#0F4F96"}` : "none", width: i === 1 ? "165px" : i === 2 ? "261px" : "auto" }}
                  >
                    {i === 2 ? (
                      <Box display="flex" alignItems="center" gap={1} justifyContent="center">
                        <Button
                          variant="outlined"
                          color="primary"
                          size="small"
                           disabled={isPending || (row?.isactive === "1" && endDate >= today) || (row?.generaterequeststatus === "inprogress")}
                          sx={{
                            minWidth: "149px", 
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "6px",
                            textTransform: "none",
                          }}
                          onClick={() => {
                            if(row?.generaterequeststatus === "completed" || row?.generaterequeststatus === "failed"){
                              handleRegenrateFunc(row, true)
                            } else {
                              handleGenerateFunc(row)
                            }
                          }}
                        >
                          {isPending || (row?.generaterequeststatus === "inprogress") ? (
                            <>
                              <CircularProgress size={16} color="inherit" />
                              Generating...
                            </>
                          ) : row?.generaterequeststatus === "completed" ? (
                            "Re-generate"
                          ) : row?.generaterequeststatus === "failed" ? (
                            "Re-try"
                          ) : (
                            "Generate"
                          )}
                        </Button>
                        <IconButton
                          color="primary"
                          onClick={() => handleDownloadDump(row, (downloadUrls[row.courseid] || row?.downloadurl))}
                          disabled={
                            // !generatedRows?.includes(row.courseid) || row.isactive == "1" || !downloadUrls[row.courseid]
                          //  !row?.downloadurl || !generatedRows?.includes(row.courseid) || !downloadUrls[row.courseid]
                           !row?.downloadurl  || (row.isactive == "1" &&  endDate >= today) || (isPending || (row?.generaterequeststatus === "inprogress"))
                          }
                        >
                          <MdOutlineFileDownload />
                        </IconButton>
                      </Box>
                    ) : param["render"]
                      ? param["render"](row[param.dataIndex], row)
                      : row[param.dataIndex]}
                  </TableCell>
                ))}
              </TableRow>
            )
            }
              
)
              ) : (
                <TableRow>
              <TableCell
                colSpan={columnData?.length}
                component="td"
               
                sx={{ textAlign: "center", color: "#0F4F96", }}
              >
                No Result Found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
    </Box>
    </div>
  );
}
